import { createNS } from "@ontologies/core";
/** Function to create arbitrary terms within the 'DCMI Metadata Terms' ontology */
export const ns = createNS("http://purl.org/dc/terms/");
/** A resource that acts or has the power to act. */
export const Agent = ns("Agent");
/** A group of agents. */
export const AgentClass = ns("AgentClass");
/** A book, article, or other documentary resource. */
export const BibliographicResource = ns("BibliographicResource");
/** The set of regions in space defined by their geographic coordinates according to the DCMI Box Encoding Scheme. */
export const Box = ns("Box");
/** A digital resource format. */
export const FileFormat = ns("FileFormat");
/** A rate at which something recurs. */
export const Frequency = ns("Frequency");
/** The set of codes listed in ISO 3166-1 for the representation of names of countries. */
export const ISO3166 = ns("ISO3166");
/** The three-letter alphabetic codes listed in ISO639-2 for the representation of names of languages. */
export const ISO639_2 = ns("ISO639-2");
/** The set of three-letter codes listed in ISO 639-3 for the representation of names of languages. */
export const ISO639_3 = ns("ISO639-3");
/** The extent or range of judicial, law enforcement, or other authority. */
export const Jurisdiction = ns("Jurisdiction");
/** A legal document giving official permission to do something with a Resource. */
export const LicenseDocument = ns("LicenseDocument");
/** A system of signs, symbols, sounds, gestures, or rules used in communication. */
export const LinguisticSystem = ns("LinguisticSystem");
/** A spatial region or named place. */
export const Location = ns("Location");
/** A location, period of time, or jurisdiction. */
export const LocationPeriodOrJurisdiction = ns("LocationPeriodOrJurisdiction");
/** A file format or physical medium. */
export const MediaType = ns("MediaType");
/** A media type or extent. */
export const MediaTypeOrExtent = ns("MediaTypeOrExtent");
/** A method by which resources are added to a collection. */
export const MethodOfAccrual = ns("MethodOfAccrual");
/** A process that is used to engender knowledge, attitudes, and skills. */
export const MethodOfInstruction = ns("MethodOfInstruction");
/** The set of time intervals defined by their limits according to the DCMI Period Encoding Scheme. */
export const Period = ns("Period");
/** An interval of time that is named or defined by its start and end dates. */
export const PeriodOfTime = ns("PeriodOfTime");
/** A physical material or carrier. */
export const PhysicalMedium = ns("PhysicalMedium");
/** A material thing. */
export const PhysicalResource = ns("PhysicalResource");
/** The set of points in space defined by their geographic coordinates according to the DCMI Point Encoding Scheme. */
export const Point = ns("Point");
/** A plan or course of action by an authority, intended to influence and determine decisions, actions, and other matters. */
export const Policy = ns("Policy");
/** A statement of any changes in ownership and custody of a resource since its creation that are significant for its authenticity, integrity, and interpretation. */
export const ProvenanceStatement = ns("ProvenanceStatement");
/** The set of tags, constructed according to RFC 1766, for the identification of languages. */
export const RFC1766 = ns("RFC1766");
/** The set of tags constructed according to RFC 3066 for the identification of languages. */
export const RFC3066 = ns("RFC3066");
/** The set of tags constructed according to RFC 4646 for the identification of languages. */
export const RFC4646 = ns("RFC4646");
/** The set of tags constructed according to RFC 5646 for the identification of languages. */
export const RFC5646 = ns("RFC5646");
/** A statement about the intellectual property rights (IPR) held in or over a Resource, a legal document giving official permission to do something with a resource, or a statement about access rights. */
export const RightsStatement = ns("RightsStatement");
/** A dimension or extent, or a time taken to play or execute. */
export const SizeOrDuration = ns("SizeOrDuration");
/** A basis for comparison; a reference point against which other things can be evaluated. */
export const Standard = ns("Standard");
/** The set of identifiers constructed according to the generic syntax for Uniform Resource Identifiers as specified by the Internet Engineering Task Force. */
export const URI = ns("URI");
/** The set of dates and times constructed according to the W3C Date and Time Formats Specification. */
export const W3CDTF = ns("W3CDTF");
/** A summary of the resource. */
export const dctermsabstract = ns("abstract");
/** Information about who can access the resource or an indication of its security status. */
export const accessRights = ns("accessRights");
/** The method by which items are added to a collection. */
export const accrualMethod = ns("accrualMethod");
/** The frequency with which items are added to a collection. */
export const accrualPeriodicity = ns("accrualPeriodicity");
/** The policy governing the addition of items to a collection. */
export const accrualPolicy = ns("accrualPolicy");
/** An alternative name for the resource. */
export const alternative = ns("alternative");
/** A class of entity for whom the resource is intended or useful. */
export const audience = ns("audience");
/** Date (often a range) that the resource became or will become available. */
export const available = ns("available");
/** A bibliographic reference for the resource. */
export const bibliographicCitation = ns("bibliographicCitation");
/** An established standard to which the described resource conforms. */
export const conformsTo = ns("conformsTo");
/** An entity responsible for making contributions to the resource. */
export const contributor = ns("contributor");
/** The spatial or temporal topic of the resource, the spatial applicability of the resource, or the jurisdiction under which the resource is relevant. */
export const coverage = ns("coverage");
/** Date of creation of the resource. */
export const created = ns("created");
/** An entity primarily responsible for making the resource. */
export const creator = ns("creator");
/** A point or period of time associated with an event in the lifecycle of the resource. */
export const date = ns("date");
/** Date of acceptance of the resource. */
export const dateAccepted = ns("dateAccepted");
/** Date of copyright. */
export const dateCopyrighted = ns("dateCopyrighted");
/** Date of submission of the resource. */
export const dateSubmitted = ns("dateSubmitted");
/** An account of the resource. */
export const description = ns("description");
/** A class of entity, defined in terms of progression through an educational or training context, for which the described resource is intended. */
export const educationLevel = ns("educationLevel");
/** The size or duration of the resource. */
export const extent = ns("extent");
/** The file format, physical medium, or dimensions of the resource. */
export const format = ns("format");
/** A related resource that is substantially the same as the pre-existing described resource, but in another format. */
export const hasFormat = ns("hasFormat");
/** A related resource that is included either physically or logically in the described resource. */
export const hasPart = ns("hasPart");
/** A related resource that is a version, edition, or adaptation of the described resource. */
export const hasVersion = ns("hasVersion");
/** An unambiguous reference to the resource within a given context. */
export const identifier = ns("identifier");
/** A process, used to engender knowledge, attitudes and skills, that the described resource is designed to support. */
export const instructionalMethod = ns("instructionalMethod");
/** A related resource that is substantially the same as the described resource, but in another format. */
export const isFormatOf = ns("isFormatOf");
/** A related resource in which the described resource is physically or logically included. */
export const isPartOf = ns("isPartOf");
/** A related resource that references, cites, or otherwise points to the described resource. */
export const isReferencedBy = ns("isReferencedBy");
/** A related resource that supplants, displaces, or supersedes the described resource. */
export const isReplacedBy = ns("isReplacedBy");
/** A related resource that requires the described resource to support its function, delivery, or coherence. */
export const isRequiredBy = ns("isRequiredBy");
/** A related resource of which the described resource is a version, edition, or adaptation. */
export const isVersionOf = ns("isVersionOf");
/** Date of formal issuance (e.g., publication) of the resource. */
export const issued = ns("issued");
/** A language of the resource. */
export const language = ns("language");
/** A legal document giving official permission to do something with the resource. */
export const license = ns("license");
/** An entity that mediates access to the resource and for whom the resource is intended or useful. */
export const mediator = ns("mediator");
/** The material or physical carrier of the resource. */
export const medium = ns("medium");
/** Date on which the resource was changed. */
export const modified = ns("modified");
/** A statement of any changes in ownership and custody of the resource since its creation that are significant for its authenticity, integrity, and interpretation. */
export const provenance = ns("provenance");
/** An entity responsible for making the resource available. */
export const publisher = ns("publisher");
/** A related resource that is referenced, cited, or otherwise pointed to by the described resource. */
export const references = ns("references");
/** A related resource. */
export const relation = ns("relation");
/** A related resource that is supplanted, displaced, or superseded by the described resource. */
export const replaces = ns("replaces");
/** A related resource that is required by the described resource to support its function, delivery, or coherence. */
export const requires = ns("requires");
/** Information about rights held in and over the resource. */
export const rights = ns("rights");
/** A person or organization owning or managing rights over the resource. */
export const rightsHolder = ns("rightsHolder");
/** A related resource from which the described resource is derived. */
export const source = ns("source");
/** Spatial characteristics of the resource. */
export const spatial = ns("spatial");
/** The topic of the resource. */
export const subject = ns("subject");
/** A list of subunits of the resource. */
export const tableOfContents = ns("tableOfContents");
/** Temporal characteristics of the resource. */
export const temporal = ns("temporal");
/** A name given to the resource. */
export const title = ns("title");
/** The nature or genre of the resource. */
export const type = ns("type");
/** Date (often a range) of validity of a resource. */
export const valid = ns("valid");
/** The set of classes specified by the DCMI Type Vocabulary, used to categorize the nature or genre of the resource. */
export const DCMIType = ns("DCMIType");
/** The set of conceptual resources specified by the Dewey Decimal Classification. */
export const DDC = ns("DDC");
/** The set of media types specified by the Internet Assigned Numbers Authority. */
export const IMT = ns("IMT");
/** The set of conceptual resources specified by the Library of Congress Classification. */
export const LCC = ns("LCC");
/** The set of labeled concepts specified by the Library of Congress Subject Headings. */
export const LCSH = ns("LCSH");
/** The set of labeled concepts specified by the Medical Subject Headings. */
export const MESH = ns("MESH");
/** The set of conceptual resources specified by the National Library of Medicine Classification. */
export const NLM = ns("NLM");
/** The set of places specified by the Getty Thesaurus of Geographic Names. */
export const TGN = ns("TGN");
/** The set of conceptual resources specified by the Universal Decimal Classification. */
export const UDC = ns("UDC");
export default {
    /** Function to create arbitrary terms within the 'DCMI Metadata Terms' ontology */
    ns,
    /** A resource that acts or has the power to act. */
    Agent,
    /** A group of agents. */
    AgentClass,
    /** A book, article, or other documentary resource. */
    BibliographicResource,
    /** The set of regions in space defined by their geographic coordinates according to the DCMI Box Encoding Scheme. */
    Box,
    /** A digital resource format. */
    FileFormat,
    /** A rate at which something recurs. */
    Frequency,
    /** The set of codes listed in ISO 3166-1 for the representation of names of countries. */
    ISO3166,
    /** The three-letter alphabetic codes listed in ISO639-2 for the representation of names of languages. */
    ISO639_2: ISO639_2,
    /** The three-letter alphabetic codes listed in ISO639-2 for the representation of names of languages. */
    ["ISO639-2"]: ISO639_2,
    /** The set of three-letter codes listed in ISO 639-3 for the representation of names of languages. */
    ISO639_3: ISO639_3,
    /** The set of three-letter codes listed in ISO 639-3 for the representation of names of languages. */
    ["ISO639-3"]: ISO639_3,
    /** The extent or range of judicial, law enforcement, or other authority. */
    Jurisdiction,
    /** A legal document giving official permission to do something with a Resource. */
    LicenseDocument,
    /** A system of signs, symbols, sounds, gestures, or rules used in communication. */
    LinguisticSystem,
    /** A spatial region or named place. */
    Location,
    /** A location, period of time, or jurisdiction. */
    LocationPeriodOrJurisdiction,
    /** A file format or physical medium. */
    MediaType,
    /** A media type or extent. */
    MediaTypeOrExtent,
    /** A method by which resources are added to a collection. */
    MethodOfAccrual,
    /** A process that is used to engender knowledge, attitudes, and skills. */
    MethodOfInstruction,
    /** The set of time intervals defined by their limits according to the DCMI Period Encoding Scheme. */
    Period,
    /** An interval of time that is named or defined by its start and end dates. */
    PeriodOfTime,
    /** A physical material or carrier. */
    PhysicalMedium,
    /** A material thing. */
    PhysicalResource,
    /** The set of points in space defined by their geographic coordinates according to the DCMI Point Encoding Scheme. */
    Point,
    /** A plan or course of action by an authority, intended to influence and determine decisions, actions, and other matters. */
    Policy,
    /** A statement of any changes in ownership and custody of a resource since its creation that are significant for its authenticity, integrity, and interpretation. */
    ProvenanceStatement,
    /** The set of tags, constructed according to RFC 1766, for the identification of languages. */
    RFC1766,
    /** The set of tags constructed according to RFC 3066 for the identification of languages. */
    RFC3066,
    /** The set of tags constructed according to RFC 4646 for the identification of languages. */
    RFC4646,
    /** The set of tags constructed according to RFC 5646 for the identification of languages. */
    RFC5646,
    /** A statement about the intellectual property rights (IPR) held in or over a Resource, a legal document giving official permission to do something with a resource, or a statement about access rights. */
    RightsStatement,
    /** A dimension or extent, or a time taken to play or execute. */
    SizeOrDuration,
    /** A basis for comparison; a reference point against which other things can be evaluated. */
    Standard,
    /** The set of identifiers constructed according to the generic syntax for Uniform Resource Identifiers as specified by the Internet Engineering Task Force. */
    URI,
    /** The set of dates and times constructed according to the W3C Date and Time Formats Specification. */
    W3CDTF,
    /** A summary of the resource. */
    abstract: dctermsabstract,
    /** Information about who can access the resource or an indication of its security status. */
    accessRights,
    /** The method by which items are added to a collection. */
    accrualMethod,
    /** The frequency with which items are added to a collection. */
    accrualPeriodicity,
    /** The policy governing the addition of items to a collection. */
    accrualPolicy,
    /** An alternative name for the resource. */
    alternative,
    /** A class of entity for whom the resource is intended or useful. */
    audience,
    /** Date (often a range) that the resource became or will become available. */
    available,
    /** A bibliographic reference for the resource. */
    bibliographicCitation,
    /** An established standard to which the described resource conforms. */
    conformsTo,
    /** An entity responsible for making contributions to the resource. */
    contributor,
    /** The spatial or temporal topic of the resource, the spatial applicability of the resource, or the jurisdiction under which the resource is relevant. */
    coverage,
    /** Date of creation of the resource. */
    created,
    /** An entity primarily responsible for making the resource. */
    creator,
    /** A point or period of time associated with an event in the lifecycle of the resource. */
    date,
    /** Date of acceptance of the resource. */
    dateAccepted,
    /** Date of copyright. */
    dateCopyrighted,
    /** Date of submission of the resource. */
    dateSubmitted,
    /** An account of the resource. */
    description,
    /** A class of entity, defined in terms of progression through an educational or training context, for which the described resource is intended. */
    educationLevel,
    /** The size or duration of the resource. */
    extent,
    /** The file format, physical medium, or dimensions of the resource. */
    format,
    /** A related resource that is substantially the same as the pre-existing described resource, but in another format. */
    hasFormat,
    /** A related resource that is included either physically or logically in the described resource. */
    hasPart,
    /** A related resource that is a version, edition, or adaptation of the described resource. */
    hasVersion,
    /** An unambiguous reference to the resource within a given context. */
    identifier,
    /** A process, used to engender knowledge, attitudes and skills, that the described resource is designed to support. */
    instructionalMethod,
    /** A related resource that is substantially the same as the described resource, but in another format. */
    isFormatOf,
    /** A related resource in which the described resource is physically or logically included. */
    isPartOf,
    /** A related resource that references, cites, or otherwise points to the described resource. */
    isReferencedBy,
    /** A related resource that supplants, displaces, or supersedes the described resource. */
    isReplacedBy,
    /** A related resource that requires the described resource to support its function, delivery, or coherence. */
    isRequiredBy,
    /** A related resource of which the described resource is a version, edition, or adaptation. */
    isVersionOf,
    /** Date of formal issuance (e.g., publication) of the resource. */
    issued,
    /** A language of the resource. */
    language,
    /** A legal document giving official permission to do something with the resource. */
    license,
    /** An entity that mediates access to the resource and for whom the resource is intended or useful. */
    mediator,
    /** The material or physical carrier of the resource. */
    medium,
    /** Date on which the resource was changed. */
    modified,
    /** A statement of any changes in ownership and custody of the resource since its creation that are significant for its authenticity, integrity, and interpretation. */
    provenance,
    /** An entity responsible for making the resource available. */
    publisher,
    /** A related resource that is referenced, cited, or otherwise pointed to by the described resource. */
    references,
    /** A related resource. */
    relation,
    /** A related resource that is supplanted, displaced, or superseded by the described resource. */
    replaces,
    /** A related resource that is required by the described resource to support its function, delivery, or coherence. */
    requires,
    /** Information about rights held in and over the resource. */
    rights,
    /** A person or organization owning or managing rights over the resource. */
    rightsHolder,
    /** A related resource from which the described resource is derived. */
    source,
    /** Spatial characteristics of the resource. */
    spatial,
    /** The topic of the resource. */
    subject,
    /** A list of subunits of the resource. */
    tableOfContents,
    /** Temporal characteristics of the resource. */
    temporal,
    /** A name given to the resource. */
    title,
    /** The nature or genre of the resource. */
    type,
    /** Date (often a range) of validity of a resource. */
    valid,
    /** The set of classes specified by the DCMI Type Vocabulary, used to categorize the nature or genre of the resource. */
    DCMIType,
    /** The set of conceptual resources specified by the Dewey Decimal Classification. */
    DDC,
    /** The set of media types specified by the Internet Assigned Numbers Authority. */
    IMT,
    /** The set of conceptual resources specified by the Library of Congress Classification. */
    LCC,
    /** The set of labeled concepts specified by the Library of Congress Subject Headings. */
    LCSH,
    /** The set of labeled concepts specified by the Medical Subject Headings. */
    MESH,
    /** The set of conceptual resources specified by the National Library of Medicine Classification. */
    NLM,
    /** The set of places specified by the Getty Thesaurus of Geographic Names. */
    TGN,
    /** The set of conceptual resources specified by the Universal Decimal Classification. */
    UDC
};
